import { createBrowserHistory } from 'history';
import { configureStore } from './configure-store';

export const history = createBrowserHistory();
export const store = configureStore(history);
